var _PInfScrLoading = false;
var _PInfScrDelay = 100;
var _ViewAllOn = 0;
var _LoadingImage = '<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />';

$.fn.setAllToMaxHeight = function(){ return this.height( Math.max.apply(this, $.map( this , function(e){ return $(e).height() }) ) );}

$(window).load(function() {
	$('ul.products-lists li a').setAllToMaxHeight();
	$('ul.products-lists li').setAllToMaxHeight();
});

function pInfScrExecute() {
	if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
		pInfScrNode = $('.more').last();	
		pInfScrURL = $('.more a').last().attr("href");
		if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none' && !_PInfScrLoading) {
			$.ajax({
				type: 'GET',
				url: pInfScrURL,
				beforeSend: function() {
					_PInfScrLoading = true;
					pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
					pInfScrNode.hide();
				},
				success: function(data) {
					// remove loading feedback
					//pInfScrNode.next().remove();
                    $('li.more').remove();//Remove previous more link
					var filteredData = $(data).find(".products-lists");
					filteredData.insertBefore( $("#product-list-foot") );
					$('ul.products-lists li a').setAllToMaxHeight();
					$('ul.products-lists li').setAllToMaxHeight();
					_PInfScrLoading = false;
				},
				dataType: "html"
			});
		}
	}
}
		

function LoadUrlInAjax(url,requestType,dataType,functionToBeExecutedBefore,callBack){
    $.ajax({
            type: requestType,
            url: url,
            beforeSend: function(){
            },
            success: function(data){
                callBack(data);
            },
            dataType: dataType
          });
}

var BeforeSendFunction = function(){
	//append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
}

var DisplayDataAndLoadNextUrl = function(data){
    $('li.more').remove();//Remove previous more link
    
	var filteredData = $(data).find(".products-lists");
	filteredData.insertBefore( $("#product-list-foot") );
	
	if($('li.more', filteredData).length == 1)
    {
        _PInfScrLoading = true;
        $('ul.products-lists li a').setAllToMaxHeight();
    	$('ul.products-lists li').setAllToMaxHeight();
		InitUrlLoader($('li.more a').attr('href'));
	}
    else
    {
        InitializeFilters();
        $('.pagination').remove();
        $('#shop-by-price').removeClass('hidden');
	}
}

function InitUrlLoader(url){
	var requestType = 'GET';
	var dataType = 'html';
	LoadUrlInAjax(url,requestType,dataType,BeforeSendFunction,DisplayDataAndLoadNextUrl);
}

function InitializeViewAllLink(){
    if($('#view-all').length > 0){
        $('#view-all').click(function(){
    		InitUrlLoader($('.more a').last().attr("href"));
            _ViewAllOn = 1;
            $('.pagination').html(_LoadingImage);
    		return false;
        });
    }
    else{
        InitializeFilters();
        $('#shop-by-price').removeClass('hidden');
    }
}

function InitializeFilters(){
	$('#shop-by-price input').prop('checked', false);
    var minPrice = 0;
	var maxPrice = 0;
	$('#shop-by-price input').each(function(){
		var priceRange = GetPriceRangeArray($(this));
		minPrice = priceRange[0];
		maxPrice = priceRange[1];
		if(priceRange.length > 1){
            var disableInput = IsRangeAvailable(minPrice,maxPrice);
            $(this).attr('disabled', disableInput);
		}
	});
    
    $('#shop-by-price input').change(function(){
        SortElementByPrice("asc");
        var priceRange = GetPriceRangeArray($(this));
		if(priceRange.length > 1){
		    minPrice = priceRange[0];
    	    maxPrice = priceRange[1];
		}else{
    	    minPrice = maxPrice = 0;
		}
        ShowProductRange(minPrice,maxPrice);
    });
}

function GetPriceRangeArray(input){
    return input.val().split("-")
}

function IsRangeAvailable(minPrice,maxPrice){
    var disableInput = true;
	$('.list-price').each(function(){
		var price = GetProductPrice($(this));
        if(parseInt(minPrice) <= parseInt(price)){
            disableInput = false;
            return false;
        }
	});
	return disableInput;
}

function ShowProductRange(minPrice, maxPrice){
	if(minPrice == 0 && maxPrice == 0 ){
		$('.products-lists li').css('display','block');
		return false;
	}
	
	$('.products-lists li .product-list-title .list-price').each(function(){
		
		var parentWrapper = $(this).parent().parent();
		var price = GetProductPrice($(this));
		
		parentWrapper.css('display','none');

		if(price >= minPrice && price <= maxPrice){
			parentWrapper.css('display','block');
		}
	});
}

function GetProductPrice(obj){
	var priceText = obj.text();
	var price = parseInt(priceText.substring(1, priceText.length));
    return price;
}

$(document).ready(function () {
    InitializeViewAllLink();
	$(window).scroll(function(){
		if(!_ViewAllOn){
			$.doTimeout( 'scroll', _PInfScrDelay, pInfScrExecute);
			if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
				_PInfScrDelay = 100;
			}
		}
	});
});

function SortElementByPrice(sortingType){
    $('.products-lists li').sortElements(function(a, b){
		var price1 = parseInt($('.list-price',a).text().substring(1,$('.list-price',a).text().length));
		var price2 = parseInt($('.list-price',b).text().substring(1,$('.list-price',a).text().length));
		if(sortingType == "asc"){
			return price1 > price2 ? 1 : -1;
		}
		else{
			return price1 < price2 ? 1 : -1;
		}
	});
}
